<template>
	<div class="outer">

		<el-carousel height="5.5rem">
			<el-carousel-item v-for="(item,index) in swiperList" :key="index">
				<img :src="$imgUrl + item.imgUrl" style="width: 100%;height: 100%;" alt="">
			</el-carousel-item>
		</el-carousel>
		<div class="content">
			<div class="center">
				<div class="zhanshi flex-row justify-between" style="align-items: center;">
					<div  style="display: flex;align-items: center;">
						<img src="../../assets/image/kj_ico1.png" alt="" class="img-item_1" />
						<div>
							<div style="font-size: 24px;font-weight: 700;color: rgb(94, 94, 94);">快速用电</div>
							<div style="color: rgb(160, 160, 160);font-size: 16px">汇通电力连万家</div>
						</div>
					</div>
					<div style="width: 1px;height: 35px;background-color: rgb(205, 205, 205);">

					</div>
					<div  style="display: flex;align-items: center;">
						<img src="../../assets/image/kj_ico2.png" alt="" class="img-item_1" />
						<div>
							<div style="font-size: 24px;font-weight: 700;color: rgb(94, 94, 94);">多种模式</div>
							<div style="color: rgb(160, 160, 160);font-size: 16px">真情服务你我他</div>
						</div>
					</div>
					<div style="width: 1px;height: 35px;background-color: rgb(205, 205, 205);">

					</div>
					<div style="display: flex;align-items: center;">
						<img src="../../assets/image/kj_ico3.png" alt="" class="img-item_1" />
						<div>
							<div style="font-size: 24px;font-weight: 700;color: rgb(94, 94, 94);">用电透明</div>
							<div style="color: rgb(160, 160, 160);font-size: 16px">为电力保驾护航</div>
						</div>
					</div>
				</div>

				<!--<div @click="clickImg">查看</div>-->

				<div class="title_1">保电类</div>
				<div class="flex-row wrap card-right section-one">
<!--					<div class="img_1">-->
<!--						<div class="text-more">更多</div>-->
<!--					</div>-->
					<div  style="margin: 0 10px 0 5px" v-for="(item,i) in carEquipmentListBd" :key="i">
						<HomeListCard :detail="item" :type="item.serviceType" @updataState="handleUpdateState()"></HomeListCard>
					</div>
				</div>

				<div class="title_1 title_2 flex-row justify-between items-center">
					<div>照明类</div>
<!--					<div class="flex-row" >-->
<!--						<div class="title-text">更多</div>-->
<!--						<img src="../../assets/image/img_6.png" alt="" class="img-go" />-->
<!--					</div>-->
				</div>
				<div class="flex-row">
<!--					<div class="img_left_1">-->
<!--						<div class="btn-top">推荐</div>-->
<!--						<div class="btn-more">更多</div>-->
<!--					</div>-->
					<div class="flex-row wrap card-right section-one">
						<div  style="margin: 0 10px 0 5px" v-for="(item,i) in carEquipmentListZm" :key="i">
							<HomeListCard :detail="item" :type="item.serviceType" @updataState="handleUpdateState()"></HomeListCard>
						</div>
					</div>
				</div>
				<div class="title_1 title_2 flex-row justify-between items-center">
					<div>其他类</div>
<!--					<div class="flex-row">-->
<!--						<div class="title-text">更多</div>-->
<!--						<img src="../../assets/image/img_6.png" alt="" class="img-go" />-->
<!--					</div>-->
				</div>
				<div class="flex-row">
<!--					<div class="img_left_1 img_left_2">-->
<!--						<div class="button-more">更多</div>-->
<!--					</div>-->
					<div class="flex-row wrap card-right section-one">
						<div  style="margin: 0 10px 0 5px" v-for="(item,i) in carEquipmentListQt" :key="i">
							<HomeListCard :detail="item" :type="item.serviceType" @updataState="handleUpdateState()"></HomeListCard>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import HomeListCard from '../../components/homeListCard.vue'
	import Imgs from "../../components/img.vue"
	import {
		swiperApi,
		equipmentListApi
	} from '../../http/api/ordinary.js'

	export default {
		components: {
			HomeListCard,Imgs
		},

    data() {
			return {
				swiperList: [],
				hostEquipmentList: [],
				carEquipmentList: [],
        carEquipmentListBd:[],
        carEquipmentListZm:[],
        carEquipmentListQt:[],
				batteryEquipmentList: [],
				imgSrc:''
			}


		},
		created() {
			this.init()
		},
		methods: {
      handleUpdateState(){

        this.init();
      },
			viewImg() {
				this.imgSrc = "";
			},

      // 跳转列表
      jump(link) {
        this.$router.push({
          path: link,
        });
      },
			clickImg() {
// 获取当前图片地址 (我在组件的地址是写死的，你们可以改为动态的)
				this.imgSrc = "../assets/image/img_2.png";
			},

			init() {
				//获取轮播图
				swiperApi({
					type: 0
				}).then(res => {
					this.swiperList = res
				})
				//获取热推精品
				equipmentListApi({
					pageSize: 10
				}).then(res => {
					this.hostEquipmentList = res.rows
				})
				//推荐发电车
				equipmentListApi({
          serviceDictValue:0,
					typeId: 1,
					pageSize: 10
				}).then(res => {
					this.carEquipmentListBd = res.rows
				})

        equipmentListApi({
          serviceDictValue:1,
          typeId: 1,
          pageSize: 10
        }).then(res => {
          this.carEquipmentListZm = res.rows
        })

        equipmentListApi({
          serviceDictValue:2,
          typeId: 1,
          pageSize: 10
        }).then(res => {
          this.carEquipmentListQt = res.rows
        })
				//推荐蓄电池
				equipmentListApi({
					typeId: 2,
					pageSize: 10
				}).then(res => {
					this.batteryEquipmentList = res.rows
				})
			}
		}
	}
</script>

<style>
	/* ---------------- 轮播图部分 start---------------------- */
	/* 展示内容容器 */
	.el-carousel__item {
		background: burlywood;
	}

	/* 指示器 */
	.outer>>>.el-carousel__indicators {
		bottom: .79rem;
		display: flex;
	}

	.outer>>>.el-carousel__indicators .el-carousel__indicator {
		padding: 0;
		align-self: end;
	}

	/* 指示器按钮 */
	.outer>>>.el-carousel__button {
		opacity: 1;
		width: .06rem;
		height: .06rem;
		border-radius: 50%;
		background-color: #fff;
		box-shadow: 0 0 0 .01rem rgba(0, 0, 0, 0.25);
		margin-right: .16rem;

	}

	/* 指示器激活按钮 */
	.outer>>>.is-active .el-carousel__button {
		width: .18rem;
		height: .06rem;
		border-radius: .03rem;
		background-color: #fff;

	}

	/* 左右切换按钮 */
	.outer>>>.el-carousel__container .el-carousel__arrow {
		background: rgba(0, 0, 0, .37);
	}

	.outer>>>.el-carousel__container .el-carousel__arrow:hover {
		background-color: rgba(31, 45, 61, .5);
	}

	.outer>>>.el-carousel__container button:nth-child(1) {
		left: 2.01rem;
	}

	.outer>>>.el-carousel__container button:nth-child(2) {
		right: 2.01rem;
	}

	/* ---------------- 轮播图部分end---------------------- */
	.content {
		background: #F5F5F5;
	}

	.center {
		width: 15.2rem;
		margin: 0 auto;
		position: relative;
		padding: 1.17rem 0 0.5rem;
	}

	.zhanshi {
		position: absolute;
		top: -0.45rem;
		box-sizing: border-box;
		width: 15.2rem;
		height: 1.14rem;
		margin: 0 auto;
		padding: 0 1.1rem 0 1.1rem;
		z-index: 2;
		background: rgba(255, 255, 255, 0.83);
		backdrop-filter: blur(15px);
		box-shadow: 0 0 0 1px rgb(233, 233, 233);
		border-radius: 0.1rem;
		overflow: hidden;
	}

	/* .zhanshi .text_1{
		font-size: .13rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #FF5400;
	}
*/
	.img-item_1 {
		width: 1rem;
		height: 1rem;
		/* margin-top: .18rem; */
		z-index: 1;
	}

	.img-item_2 {
		width: .56em;
		height: .82rem;
		margin-top: .19rem;
		z-index: 1;
	}

	.img-item_3 {
		width: .52em;
		height: .75rem;
		margin-top: .21rem;
		z-index: 1;
	}

	/* -------热推精品 start------- */
	.section-one {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		//justify-content: space-between;
	}

	.title_1 {
		height: .39rem;
		font-size: .28rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #333333;
		line-height: .39rem;
		margin-bottom: .22rem;
    margin-left: 0.1rem;
	}

	.img_1 {
		width: 5.8rem;
		height: 3.8rem;
		background: url('../../assets/image/img_1.png') no-repeat;
		background-size: cover;
		position: relative;
		/* margin-right: .07rem; */
		margin-right: 12px;
	}

	.text-more {
		position: absolute;
		right: .39rem;
		bottom: .38rem;
		width: .61rem;
		height: .28rem;
		background: #FF5400;
		border-radius: .03rem;
		font-size: .14rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #FFFFFF;
		line-height: .28rem;
		text-align: center;
	}

	/* -------热推精品 end-------- */
	/* -------推荐发电车 start ---- */
	.title_2 {
		margin: .34rem 0.1rem .23rem;
	}

	.title-text {
		font-size: .14rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #8D8D8D;
		line-height: .2rem;
		margin-right: .07rem;
	}

	.img_left_1 {
		position: relative;
		width: 2.86rem;
		height: 7.74rem;
		display: inline-block;
		background-image: url('../../assets/image/img_4.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		border-radius: .07rem;
		margin-right: .2rem;
	}

	.img_left_1 .btn-top {
		position: absolute;
		top: .97rem;
		left: .95rem;
		width: 1.04rem;
		height: .29rem;
		background: #FFFFFF;
		font-size: .14rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #104E7D;
		line-height: .29rem;
		text-align: center;
	}

	.img_left_1 .btn-more {
		position: absolute;
		left: .38rem;
		bottom: .22rem;
		width: .61rem;
		height: .28rem;
		background: #FFFFFF;
		border-radius: .03rem;
		font-size: .14rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #000000;
		line-height: .28rem;
		text-align: center;
	}

	.img_left_2 {
		background-image: url('../../assets/image/img_5.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
	}

	.img_left_2 .button-more {
		position: absolute;
		left: .38rem;
		bottom: .31rem;
		width: .61rem;
		height: .28rem;
		background: #FFFFFF;
		border-radius: .03rem;
		font-size: .14rem;
		font-family: PingFang SC-Regular, PingFang SC;
		color: #000000;
		line-height: .28rem;
		text-align: center;
	}

	.card-right {
		//width: 12.11rem;
	}

	.img-go {
		width: .08rem;
		height: .12rem;
		margin-top: .04rem;
	}

	/* -------推荐发电车 end ---- */
  .shoppingCar{
    position: fixed;
    top: 600px;
    right: 10px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #ccc;padding: 5px;
    border-radius: 2px;
  }

  .shoppingCar:hover  {
    background-color: #ccc !important;
  }
</style>
